export async function streamAnswer(
  readableStream: ReadableStream,
  on: (text: string) => void,
  end: (text: string) => void,
): Promise<void> {
  const reader = readableStream.getReader();

  let runningText = '';

  while (true) {
    const { done, value } = await reader.read();

    if (done) break;

    const text = new TextDecoder('utf-8').decode(value);

    runningText += text;

    on(runningText);
  }

  await reader.closed;

  end(runningText);
}
